// FixedKitComponents.js
// ---------------------------------------------------------------------------
// Components that get wired to specific ports AUTOMATICALLY when an internal
// output toggle is enabled (on the internal-accessories screen). They render
// like any normal connected component in the assembly board and the logic
// panels, but the user CANNOT drag or delete them (see Component.js `fixed`)
// and CANNOT drop anything else on their ports (see IsOverPort.js).
//
// Structure — keyed by connectedDevice, then by the INTERNAL-OUTPUT FLAG that
// gates that group, then by the board port the component occupies:
//   FIXED_KIT_COMPONENTS[device][gateFlag][port] = {
//       type,       // component type to place (must exist in Comp_Img/data.js)
//       left, top,  // workspace coordinates the graphic is drawn at (tune visually)
//   }
// Each gateFlag is an `internalaccessories` redux flag; when it is true the
// group is seeded, when false it is removed. Groups are independent.
//
// For woofKit:
//   isIndivdualServo → 4 servos on S1(servo_motor1), S2(servo_motor2), A1, A2
//   isWoofOled       → OLED on the E socket (Poki wires OLED to E — see
//                      AllowedPortTypes.js POKI1: OLED: ['E'])
export const FIXED_KIT_COMPONENTS = {
    woofKit: {
        isIndivdualServo: {
            // S1
            servo_motor1: { type: 'servo_motor', left: 470, top: 100 },
            // S2
            servo_motor2: { type: 'servo_motor', left: 920, top: 108 },
            A1: { type: 'servo_motor', left: 420, top: 217 },
            A2: { type: 'servo_motor', left: 940, top: 227 },
        },
        isWoofOled: {
            E: { type: 'OLED', left: 250, top: 210 },
        },
    },
}

// Every port covered by any fixed group for a device (across all gate flags).
export const getFixedPortsForDevice = (device) =>
    Object.values(FIXED_KIT_COMPONENTS[device] || {}).flatMap((group) =>
        Object.keys(group)
    )

// Every distinct component type used by a device's fixed groups. Used to make
// sure their props exist even though they aren't in the external accessory list.
export const getFixedTypesForDevice = (device) => {
    const types = new Set()
    Object.values(FIXED_KIT_COMPONENTS[device] || {}).forEach((group) =>
        Object.values(group).forEach((cfg) => types.add(cfg.type))
    )
    return [...types]
}
